var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0458 5.0365C12.5428 2.98783 15.4572 2.98783 15.9542 5.0365C16.1054 5.66074 16.5457 6.17519 17.1391 6.42104C17.7325 6.66688 18.4076 6.61453 18.956 6.28017C20.7562 5.1835 22.8177 7.24383 21.721 9.04517C21.3871 9.59333 21.3349 10.2679 21.5804 10.8609C21.826 11.454 22.3398 11.8942 22.9635 12.0458C25.0122 12.5428 25.0122 15.4572 22.9635 15.9542C22.3393 16.1054 21.8248 16.5457 21.579 17.1391C21.3331 17.7325 21.3855 18.4076 21.7198 18.956C22.8165 20.7562 20.7562 22.8177 18.9548 21.721C18.4067 21.3871 17.7321 21.3349 17.1391 21.5804C16.546 21.826 16.1058 22.3398 15.9542 22.9635C15.4572 25.0122 12.5428 25.0122 12.0458 22.9635C11.8946 22.3393 11.4543 21.8248 10.8609 21.579C10.2675 21.3331 9.5924 21.3855 9.044 21.7198C7.24383 22.8165 5.18233 20.7562 6.279 18.9548C6.61289 18.4067 6.6651 17.7321 6.41955 17.1391C6.174 16.546 5.66017 16.1058 5.0365 15.9542C2.98783 15.4572 2.98783 12.5428 5.0365 12.0458C5.66074 11.8946 6.17519 11.4543 6.42104 10.8609C6.66688 10.2675 6.61453 9.5924 6.28017 9.044C5.1835 7.24383 7.24383 5.18233 9.04517 6.279C10.2118 6.98833 11.7238 6.36067 12.0458 5.0365Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 14,
    r: 3.5,
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingsIcon);
export default __webpack_public_path__ + "static/media/settings-icon.dc9f557a31016eba235e8ac5d0162073.svg";
export { ForwardRef as ReactComponent };